import { useState, useEffect, useCallback } from 'react'
import { getLrrHtmlForStandaloneViewer } from '../fetch/get-lrr-html-for-standalone-viewer'

interface UseLrrHtmlState {
  data: string | null
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

/**
 * Fetch LRR HTML content for the standalone viewer.
 *
 * @param s3Path - The s3 path
 */
export function useLrrHtmlInStandalone(s3Path: string): UseLrrHtmlState {
  const [data, setData] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const fetchData = useCallback(async () => {
    if (!s3Path) {
      setIsError(true)
      setData(null)
      return
    }

    setIsLoading(true)
    setIsError(false)

    try {
      const result = await getLrrHtmlForStandaloneViewer(s3Path)
      setData(result.data)
    } catch {
      setIsError(true)
      setData(null)
    } finally {
      setIsLoading(false)
    }
  }, [s3Path])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    data,
    isLoading,
    isError,
    refetch: fetchData,
  }
}
